<script setup lang="ts">
import { BrandProps } from "./Brand.props"

defineProps<BrandProps>()
</script>

<template>
  <div
    class="
      flex
      h-full
      w-60
      flex-col
      items-start
      gap-4
      rounded-lg
      bg-white
      p-4
      shadow-01
      hover:shadow-02
      md:w-auto
      md:flex-row
      md:items-center
      md:gap-6
    "
  >
    <div v-if="logoImage" class="h-10 overflow-hidden md:h-auto md:w-20">
      <UtilsWrapperImage
        v-bind="logoImage"
        class="wrapper-image-full-container-centered"
      />
    </div>
    <div class="flex h-full flex-col justify-between gap-1">
      <p v-if="title" class="beaver-bold line-clamp-1 flex-grow-0">
        {{ title }}
      </p>
      <UtilsMarkdown
        v-if="description"
        class="mouse line-clamp-2"
        :content="description"
      />
      <UtilsButton
        theme="ghost-green"
        :text="`${$t('card.blogCard.discoverProducts')}`"
        :path="path"
        order="last"
        class="hover:[&>*]:underline [&>span]:justify-start [&>span]:pl-0"
      >
        <template #icon>
          <UtilsIcon name="ArrowRight.svg" color="green-main" class="h-5 w-5" />
        </template>
      </UtilsButton>
    </div>
  </div>
</template>
